import * as React from "react";
import Jobs from "../components/Careers/Jobs";
// import Inquiries from "../components/Home/Inquiries";
// import { Link } from "gatsby"

import Layout from "../components/layout";
import Seo from "../components/seo";

const Careers = () => (
  <Layout>
    <Seo title="Careers" />
    <Jobs />
    {/* <Inquiries /> */}
  </Layout>
);

export default Careers;
